import {Component, OnDestroy, OnInit} from '@angular/core';
import {Observable, Subscription} from 'rxjs';
import {Store} from '@ngrx/store';
import {AppState, selectAuthState, selectDoctorState} from '../../../../store/app.states';
import {DoctorService} from '../../../../services/doctor.service';
import {Chart} from "chart.js";

@Component({
  selector: 'app-doughnut-chart-personal-patients',
  templateUrl: './doughnut-chart-personal-patients.component.html',
  styleUrls: ['./doughnut-chart-personal-patients.component.css']
})
export class DoughnutChartPersonalPatientsComponent implements OnInit, OnDestroy {
  //
  getAuthState: Observable<any>;
  getDoctorState: Observable<any>;
  isAuthenticated: boolean;
  user = null;
  errorMessage = null;
  subscription1: Subscription;
  subscription2: Subscription;
  subscription3: Subscription;
  subscription5: Subscription;
  title = "Pazienti personali";
  destination = 'general-status';
  // ******************************************************************************************************************
  // inizializzazione per i doughnut charts sul numero di utenti per malattia
  // ******************************************************************************************************************
  CPatients: number;
  APatients: number;
  UCPatients: number;
  // hover
  isHovered = false;
  public totalPatientsD = 0;
  // ******************************************************************************************************************
  // Grafici doughnut per il numero di pazienti globali e personali divisi per tipo di malattia
  // ******************************************************************************************************************
  public colorsOptions = [{
    backgroundColor: [
      '#ff9933',
      '#336699',
      '#66ccff',
    ],
    hoverbackgroundColor: [
      '#c46200',
      '#214262',
      '#0098e5',
    ]
  }];
  public doughnutChartOptions = {
    legend: {
      onHover: (event: MouseEvent, legendItem: Chart.ChartLegendLabelItem) => {
        // tslint:disable-next-line:max-line-length
        if (legendItem.text.length > 0 && (legendItem.text === 'Crohn' || legendItem.text === 'Rettocolite Ulcerosa' || legendItem.text === 'Altro')) {
          this.setHoverVariable();
        } else {
          this.unsetHoverVariable();
        }
      },
      display: true,
      position: 'top',
      align: 'left',
      textDirection: 'ltr',
      labels: {
        usePointStyle: true,
        fontColor: '#006192',
        fontSize: 18,
        fontFamily: 'Helvetica',
      }
    },
    cutoutPercentage: 70,
    tooltips: {
      content: '{pathology}: {number}',
      backgroundColor: '#1c1c1c',
      titleColor: '#f0d7f7',
      bodyFontSize: 18,
      titleFontSize: 18,
      cornerRadius: 5,
      caretPadding: 10
    }
  };
  public headElements = ['pathology', 'number'];
  public elements: any = [
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {total: ''}
  ];
  public elementsD: any = [
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {pathology: '', number: ''},
    {total: ''}
  ];
  public doughnutChartLabels = ['Crohn', 'Rettocolite Ulcerosa', 'Altro'];
  public doughnutChartData = []; // sono i dati che vanno presi dal database tramite delle richieste
  public doughnutChartDataDoctor = []; // sono i dati che vanno presi dal database, riferiti ai pazienti del singolo medico
  public doughnutChartType = 'doughnut';

  constructor(private store: Store<AppState>,
              private doctorService: DoctorService) {
    this.getAuthState = this.store.select(selectAuthState);
    this.getDoctorState = this.store.select(selectDoctorState); }

  ngOnInit(): void {
    this.subscription5 = this.getAuthState.subscribe((state) => {
      this.isAuthenticated = state.isAuthenticated;
      this.user = JSON.parse(localStorage.getItem('user'));
      this.errorMessage = state.errorMessage;
      this.retrievedata4();
    });
  }
  ngOnDestroy(): void {
    this.subscription1.unsubscribe();
    this.subscription2.unsubscribe();
    this.subscription3.unsubscribe();
    this.subscription5.unsubscribe();
  }

  retrievedata4() {
    this.subscription1 = this.doctorService.getCrohnPatientsNumber().subscribe(
      CrohnPatients => {
        // console.log(CrohnPatients);
        localStorage.setItem('CPatients', CrohnPatients.toString());
        this.doughnutChartDataDoctor.push(CrohnPatients);
        this.elementsD[0].pathology = 'Malattia di Crohn';
        this.elementsD[0].number = CrohnPatients.toString();
        this.totalPatientsD = +parseInt(CrohnPatients.toString());
        console.log('4');
        this.retrievedata5();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  retrievedata5() {
    // prendo dal database il numero di tutti i pazienti che soffrono di colite ulcerosa del singolo dottore
    this.subscription2 = this.doctorService.getColiteUlcerosaPatientsNumber().subscribe(
      ColitePatients => {
        // console.log(ColitePatients);
        localStorage.setItem('UCPatients', ColitePatients.toString());
        this.doughnutChartDataDoctor.push(ColitePatients);
        this.elementsD[1].pathology = 'Rettocolite Ulcerosa';
        this.elementsD[1].number = ColitePatients.toString();
        this.totalPatientsD += parseInt(ColitePatients.toString());
        console.log('5');
        this.retrievedata6();
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }

  retrievedata6() {
    // prendo dal database il numero di tutti i pazienti che soffrono di altro del singolo dottore
    this.subscription3 = this.doctorService.getAltroPatientsNumber().subscribe(
      AltroPatients => {
        // console.log(AltroPatients);
        // console.log(this.APatients);
        localStorage.setItem('APatients', AltroPatients.toString());
        this.doughnutChartDataDoctor.push(AltroPatients);
        this.elementsD[2].pathology = 'Altro';
        this.elementsD[2].number = AltroPatients.toString();
        this.totalPatientsD += parseInt(AltroPatients.toString());
        console.log('6');
      }, error => {
        if (error.status === 500) {
          localStorage.setItem('expirationTime', '0');
          console.log('SESSIONE SCADUTA');
          location.reload();
        }
      });
  }
  // set hovered variable of Never Logged
  setHoverVariable(): void {
    this.isHovered = true;
  }
  // unset hovered variable of Never Logged
  unsetHoverVariable(): void {
    this.isHovered = false;
  }
}
